// Third-party
import React from 'react';

// Utils
import { formatMessageWithLocale, formatLocalizedString, FormattedMessage } from '../../../../utils/i18n';
import { enumerateJSX } from '../../../../utils/objects';
import { DISCLAIMER_KEYS } from '../../../../utils/disclaimers/constants';
import { COMPARISON_ITEM_TYPES } from '../../../../utils/constants';
import Dictionary from '@/types/dictionary';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';
import BenchmarkProviderData from '@/types/benchmark-provider-data';

interface Props {
  items: ComparisonItem[];
  locale?: Locale;
}

const BenchmarksDisclaimer = ({ items, locale }: Props) => {
  const disclaimerData: BenchmarkProviderData[] = items.reduce((acc, curr) => {
    if (
      curr.type === COMPARISON_ITEM_TYPES.BENCHMARK &&
      !!curr.disclaimers &&
      !!curr.disclaimers[DISCLAIMER_KEYS.BENCHMARK_PROVIDERS] &&
      !!curr.disclaimers[DISCLAIMER_KEYS.BENCHMARK_PROVIDERS].data
    ) {
      const data = curr.disclaimers[DISCLAIMER_KEYS.BENCHMARK_PROVIDERS].data as BenchmarkProviderData[];
      acc.push(...data);
    }
    return acc;
  }, [] as BenchmarkProviderData[]);

  const groupedDisclaimers = disclaimerData.reduce(
    (acc, curr) => {
      acc[curr.key] = acc[curr.key] || [];
      acc[curr.key].push(curr);
      return acc;
    },
    {} as Dictionary<BenchmarkProviderData[]>,
  );

  if (Object.keys(groupedDisclaimers).length > 0) {
    return (
      <span className="disclaimer">
        <FormattedMessage locale={locale} id="Disclaimers.Benchmarks" />
        {enumerateJSX(
          Object.entries(groupedDisclaimers).map(groupedDisclaimer => (
            <span key={groupedDisclaimer[1][0].id}>
              {formatLocalizedString(groupedDisclaimer[1][0].providerName)}
              {groupedDisclaimer[1][0].url && (
                <>
                  &nbsp;
                  <a rel="noopener noreferrer" target="_blank" href={groupedDisclaimer[1][0].url}>
                    {groupedDisclaimer[1][0].url}
                  </a>
                </>
              )}
            </span>
          )),
          formatMessageWithLocale('Common.And', locale),
        )}
        .&nbsp;
      </span>
    );
  }
  return null;
};

export default BenchmarksDisclaimer;
